// extracted by mini-css-extract-plugin
export default {"container":"Lk-z","bubbleNav":"Mk-z","graphic":"Nk-z","contact":"Ok-z"};